import React from 'react';

import AccountDetails from './AccountDetails';
import LockedManageAccount from './LockedManageAccount';
import ManageAccount from './ManageAccount';

import { Account, Card } from '../data';

export interface Props {
  card: Card;
  cardPendingVerification: Card | null;
  account: Account;
  isAccountOrCustomerLocked?: boolean;
  showOpenSpendingAccountChangeModal: boolean;
}

const Manage: React.FC<React.PropsWithChildren<Props>> = ({
  card,
  cardPendingVerification,
  account,
  isAccountOrCustomerLocked,
  showOpenSpendingAccountChangeModal,
}) => {
  return (
    <>
      <AccountDetails account={account} />

      {isAccountOrCustomerLocked ? (
        <LockedManageAccount />
      ) : (
        <ManageAccount
          account={account}
          card={card}
          cardPendingVerification={cardPendingVerification}
          showOpenSpendingAccountChangeModal={showOpenSpendingAccountChangeModal}
        />
      )}
    </>
  );
};

export default Manage;
